// Small byte helpers for the Bluetooth Mesh stack — no Buffer, so the same code
// runs in the Capacitor webview and under Jest. Ported from the cob-mesh-reactjs
// sampler (src/util/bytes.ts).

export const hex = (b) => Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');

export const fromHex = (h) => {
  const s = String(h || '').replace(/[^0-9a-fA-F]/g, '');
  if (s.length % 2) throw new Error('odd hex length');
  const out = new Uint8Array(s.length / 2);
  for (let i = 0; i < out.length; i += 1) out[i] = parseInt(s.substr(i * 2, 2), 16);
  return out;
};

export const concat = (...parts) => {
  const len = parts.reduce((n, p) => n + p.length, 0);
  const out = new Uint8Array(len);
  let o = 0;
  for (const p of parts) {
    out.set(p, o);
    o += p.length;
  }
  return out;
};

export const ascii = (s) => Uint8Array.from(s, (ch) => ch.charCodeAt(0));

export const equal = (a, b) => a.length === b.length && a.every((v, i) => v === b[i]);

export const xor = (a, b) => a.map((v, i) => v ^ b[i]);

/* eslint-disable no-bitwise */
export const u16be = (v) => Uint8Array.of((v >> 8) & 0xff, v & 0xff);
export const u16le = (v) => Uint8Array.of(v & 0xff, (v >> 8) & 0xff);
export const u24be = (v) => Uint8Array.of((v >> 16) & 0xff, (v >> 8) & 0xff, v & 0xff);
export const u32be = (v) => Uint8Array.of((v >>> 24) & 0xff, (v >> 16) & 0xff, (v >> 8) & 0xff, v & 0xff);

export const readU16be = (b, o) => (b[o] << 8) | b[o + 1];
export const readU16le = (b, o) => b[o] | (b[o + 1] << 8);
/* eslint-enable no-bitwise */

export const randomBytes = (n) => {
  const out = new Uint8Array(n);
  // eslint-disable-next-line no-undef
  globalThis.crypto.getRandomValues(out);
  return out;
};

/** DataView (what @capacitor-community/bluetooth-le hands back) -> Uint8Array. */
export const fromDataView = (dv) => new Uint8Array(dv.buffer, dv.byteOffset, dv.byteLength).slice();

/** Uint8Array -> DataView for the plugin's write calls. */
export const toDataView = (b) => new DataView(b.buffer.slice(b.byteOffset, b.byteOffset + b.byteLength));
